const m={small:"xs",medium:"sm",large:"md"};export{m as DIALOG_SIZE_MAP};
//# sourceMappingURL=constants.js.map
